class SearchField extends HTMLElement {
  connectedCallback() {
    if (this.initialized || this.dataset.context !== 'results') return;

    this.form = this.querySelector('form');
    this.input = this.querySelector('input[type="search"]');
    this.reset = this.querySelector('.results_search_reset');
    this.error = this.querySelector('.hom-search-field__error');

    if (!this.form || !this.input || !this.reset) return;

    this.initialized = true;
    this.form.addEventListener('submit', this.handleSubmit);
    this.input.addEventListener('input', this.handleInput);
    this.reset.addEventListener('click', this.handleReset);
    this.syncResetVisibility();
  }

  disconnectedCallback() {
    if (!this.initialized) return;

    this.form.removeEventListener('submit', this.handleSubmit);
    this.input.removeEventListener('input', this.handleInput);
    this.reset.removeEventListener('click', this.handleReset);
    this.initialized = false;
  }

  handleSubmit = (event) => {
    this.input.value = this.input.value.trim();
    if (this.input.value) return;

    event.preventDefault();
    this.input.setAttribute('aria-invalid', 'true');
    if (this.error) this.error.hidden = false;
    this.input.focus();
  };

  handleInput = () => {
    this.clearError();
    this.syncResetVisibility();
  };

  handleReset = () => {
    this.input.value = '';
    this.clearError();
    this.syncResetVisibility();

    if (this.dataset.clearUrl) {
      window.location.assign(this.dataset.clearUrl);
      return;
    }

    this.input.focus();
  };

  clearError() {
    this.input.removeAttribute('aria-invalid');
    if (this.error) this.error.hidden = true;
  }

  syncResetVisibility() {
    this.reset.hidden = this.input.value.length === 0;
  }
}

if (!customElements.get('search-field')) {
  customElements.define('search-field', SearchField);
}
